






























































































import { defineComponent, PropType } from '@vue/composition-api'
import Comment from '@/classes/Comment'
import useBreakpoint from '@/composables/use-breakpoint'
import Store from '@/classes/Store'

export default defineComponent({
  props: {
    store: {
      type: Object as PropType<Store>,
      required: true,
    },
    comment: {
      type: Object as PropType<Comment>,
      required: true,
    },
  },
  setup () {
    const { match } = useBreakpoint()
    const isMobile = !match('lg')

    const handleCommentBlockClick = (e: any) => {
      if (e.target.classList.contains('expand')) {
        e.target.classList.remove('expand')
      } else { e.target.classList.add('expand') }
    }

    return {
      isMobile,
      handleCommentBlockClick,
    }
  },
})
